import { render, staticRenderFns } from "./DataClientQuotations.vue?vue&type=template&id=5fc83fda&scoped=true&lang=pug"
import script from "./DataClientQuotations.vue?vue&type=script&lang=js"
export * from "./DataClientQuotations.vue?vue&type=script&lang=js"
import style0 from "./DataClientQuotations.vue?vue&type=style&index=0&id=5fc83fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc83fda",
  null
  
)

export default component.exports